import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import GenericGrid from 'pages/tables/GenericGrid';
import PropTypes from 'prop-types';
import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
} from 'react';
import { getSearchParams } from '../../../commons/models/params';
import InventoryBuilder from './InventoryBuilder';
import { useLocation } from 'react-router-dom';
import * as r from 'constants/routes';
import { useGetInventaireQuery } from '../../../redux/api/cache';

export default function ProductInventory(props) {
  const [inventory, setInventory] = useState(false);
  const [affichageDetaille, setAffichageDetaille] = useState(false);

  const gridRef = useRef(null);
  const location = useLocation();

  const rowClicked = (rowData) => {
    location.search = `Inventaire=${rowData.ID}`;
    setInventory(rowData);
  };

  const { data, isLoading } = useGetInventaireQuery({ query: `${r.INV_PREFIX_QUERY}ptr=${getSearchParams('Produit', location.pathname)}&bannExpl=${affichageDetaille ? 'Oui' : 'Non'}` });
  const [filteredData, setFilteredData] = useState(data);

  useEffect(() => {
    if (data?.data && data?.data?.entete?.length>0) {
      let mode = 1;
      if (data?.data?.entete[0].estGerant || affichageDetaille) {
        mode = 2;
      }
      setFilteredData({ ...data, data: { ...data.data, detail: data.data.detail?.filter(d => d.aff_bann_expl === 0 || d.aff_bann_expl === mode) } });
    }
  }, [data, affichageDetaille])

  useEffect(() => {
    gridRef?.current?.scrollIntoView();
  }, []);

  return (
    <Fragment>
      {isLoading && <LoadingCard title='Chargement Inventaire Produit...' />}
      {!isLoading && filteredData?.data && filteredData?.meta && (
        <Fragment>
          <Card expanded={filteredData?.data?.detail?.length > 0 || isLoading}>
            <Header title={`Inventaire Produit`}></Header>
            <Body>
              <div ref={gridRef}>
                <GenericGrid
                  autoSize={true}
                  showCreateBtn={true}
                  rowClicked={rowClicked}
                  definition={filteredData.meta.definition.filter(
                    (x) => x.typeReq === 'detail'
                  )}
                  data={filteredData.data.detail ? filteredData.data.detail : []}
                  txtBtn={affichageDetaille ? 'Réduire les bannières' : 'Éclater les bannières'}
                  onCreateClick={() => { setAffichageDetaille(!affichageDetaille); }}
                />
              </div>
            </Body>
          </Card>
          <InventoryBuilder
            product={props.data}
            inventory={inventory}
            num={filteredData?.data?.entete[0]?.prod_num}
          />
        </Fragment>
      )}
    </Fragment>
  );
}

ProductInventory.propTypes = {
  data: PropTypes.shape({
    rowData: PropTypes.shape({
      ann_seq: PropTypes.any,
    }),
  }),
  path: PropTypes.string,
};
